<template>
  <div v-if="hasPerm">
    <div class="bg-white p-2">
      <div class="bg-slate-100 p-2 rounded-xl mb-2">
        <div class="flex items-center gap-4 my-2">
          <div>
            <v-icon
              :icon="attendanceCheck?.status == 'in' ? 'material-symbols:login' : 'material-symbols:logout'"
              class="text-4xl"
            />
          </div>
          <div>
            <p class="text-lg font-semibold">
              {{ attendanceCheck?.status == "in" ? "Absen Masuk" : "Absen Keluar" }}
            </p>
            <p class="text-sm opacity-60">
              {{ attendanceCheck?.message || "Tidak ada data absensi." }}
            </p>
            <div class="mt-1 text-md" v-if="attendanceCheck?.data?.checkIn">
              <p>Terakhir Check-In</p>
              <p class="font-bold">
                {{ attendanceCheck.data?.checkIn ? formatTime(attendanceCheck.data?.checkIn) : "Belum ada" }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-2">
        <RouterLink
          to="/dashboard/attendance/new/in"
          class="flex items-center justify-center bg-primary text-black rounded-xl py-2 w-full"
        >
          <v-icon icon="material-symbols:login" class="text-2xl mr-2" />
          Absen Masuk
        </RouterLink>
        <RouterLink
          to="/dashboard/attendance/new/out"
          class="flex items-center justify-center bg-secondary text-white rounded-xl py-2 w-full"
        >
          <v-icon icon="material-symbols:logout" class="text-2xl mr-2" />
          Absen Keluar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from "@/plugins/axios";
  import dayjs from "dayjs";
  import { users } from "@/states/user";

  export default {
    data() {
      return {
        attendanceCheck: null,
        users
      };
    },
    mounted() {
      instance.get("/attendance/@me/check").then((res) => {
        this.attendanceCheck = res.data;
      });
    },
    computed: {
      hasPerm() {
        return this.users?.data?.occupationMenus ? this.users.data.occupationMenus.includes("attendance") : false;
      }
    },
    methods: {
      formatTime(date, format = "DD MMM, HH:mm") {
        return dayjs(date).format(format);
      }
    }
  };
</script>
